import type { BetterFetchOption } from '@better-fetch/fetch'
import type { BetterAuthClientPlugin } from 'better-auth/client'

import type { SchoolClass } from '@package/drizzle/schema'

import type { childAuthPlugin } from './server'

export const childAuthClientPlugin = () => {
  return {
    id: 'child-pin',
    $InferServerPlugin: {} as ReturnType<typeof childAuthPlugin>,
    getActions: ($fetch) => {
      return {
        signInChild: async (
          data: {
            organizationPin: string
            childPin: string
          },
          fetchOptions?: BetterFetchOption,
        ) => {
          const res = await $fetch('/sign-in/child', {
            method: 'POST',
            body: data,
            ...fetchOptions,
          })
          return res
        },
        signUpChild: async (
          data: {
            name: string
            organizationId?: string
            image?: string
            teamId?: string
            /** Grade level (`user.school_class`), set at creation. */
            schoolClass?: SchoolClass
          },
          fetchOptions?: BetterFetchOption,
        ) => {
          const res = await $fetch('/sign-up/child', {
            method: 'POST',
            body: data,
            ...fetchOptions,
          })
          return res
        },
      }
    },
  } satisfies BetterAuthClientPlugin
}
